import Mutations from '../../odata/mutations';

export default { ...new Mutations('dailyInspection'), ...new Mutations('dailyInspections') };
